@primary-50: hsl(313.333333, 100%, 98.235294%);
@primary-100: hsl(321.176471, 100%, 96.666667%);
@primary-150: hsl(320, 92.307692%, 94.901961%);
@primary-200: hsl(321.290323, 88.571429%, 93.137255%);
@primary-250: hsl(318.461538, 82.978723%, 90.784314%);
@primary-300: hsl(317.5, 80%, 88.235294%);
@primary-350: hsl(315, 77.777778%, 85.882353%);
@primary-400: hsl(313.333333, 74.117647%, 83.333333%);
@primary-450: hsl(314.157303, 73.553719%, 76.27451%);
@primary-500: hsl(315, 72.5%, 68.627451%);
@primary-550: hsl(314.482759, 70.731707%, 59.803922%);
@primary-600: hsl(312.964824, 84.680851%, 46.078431%);
@primary-650: hsl(313.371429, 87.939698%, 39.019608%);
@primary-700: hsl(313.509934, 92.638037%, 31.960784%);
@primary-750: hsl(313.700787, 96.946565%, 25.686275%);
@primary-800: hsl(314.257426, 100%, 19.803922%);
@primary-850: hsl(314.805195, 100%, 15.098039%);
@primary-900: hsl(316.363636, 100%, 10.784314%);
@primary-950: hsl(319.411765, 100%, 6.666667%);
@accent-50: hsl(196, 100%, 97.058824%);
@accent-100: hsl(200, 100%, 94.705882%);
@accent-150: hsl(198.461538, 95.121951%, 91.960784%);
@accent-200: hsl(199.2, 92.592593%, 89.411765%);
@accent-250: hsl(198.181818, 97.058824%, 86.666667%);
@accent-300: hsl(197.560976, 100%, 83.921569%);
@accent-350: hsl(197.142857, 100%, 80.784314%);
@accent-400: hsl(196.173913, 100%, 77.45098%);
@accent-450: hsl(199.636364, 100%, 67.647059%);
@accent-500: hsl(202.396313, 100%, 57.45098%);
@accent-550: hsl(206.352941, 100%, 50%);
@accent-600: hsl(217.339056, 98.312236%, 53.529412%);
@accent-650: hsl(216.6, 89.285714%, 43.921569%);
@accent-700: hsl(216.071429, 94.382022%, 34.901961%);
@accent-750: hsl(216.716418, 97.101449%, 27.058824%);
@accent-800: hsl(217.2, 100%, 19.607843%);
@accent-850: hsl(219.74026, 100%, 15.098039%);
@accent-900: hsl(222.545455, 100%, 10.784314%);
@accent-950: hsl(229.411765, 100%, 6.666667%);
@grey-50: hsl(0, 0%, 98.039216%);
@grey-100: hsl(0, 0%, 96.078431%);
@grey-150: hsl(0, 0%, 94.117647%);
@grey-200: hsl(0, 0%, 92.156863%);
@grey-250: hsl(200, 5.660377%, 89.607843%);
@grey-300: hsl(195, 6.060606%, 87.058824%);
@grey-350: hsl(197.142857, 8.860759%, 84.509804%);
@grey-400: hsl(200, 9.89011%, 82.156863%);
@grey-450: hsl(204, 6.25%, 68.627451%);
@grey-500: hsl(198, 4.385965%, 55.294118%);
@grey-550: hsl(198, 4.587156%, 42.745098%);
@grey-600: hsl(201.818182, 7.006369%, 30.784314%);
@grey-650: hsl(204, 7.352941%, 26.666667%);
@grey-700: hsl(204, 8.62069%, 22.745098%);
@grey-750: hsl(204, 10.416667%, 18.823529%);
@grey-800: hsl(206.666667, 11.688312%, 15.098039%);
@grey-850: hsl(205.714286, 12.727273%, 10.784314%);
@grey-900: hsl(204, 15.151515%, 6.470588%);
@grey-950: hsl(210, 28.571429%, 2.745098%);
